// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonRgb_button__DzTB3","animate":"buttonRgb_animate__fzhJ1","text":"buttonRgb_text__FOzPx"};